import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import NavigationSetter from "./routes/NavigationSetter";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./features/auth/Login";
import Dashboard from "./features/dashboard/Dashboard";

function App() {
  return (
    <Router>
      <AuthProvider>
        <NavigationSetter />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
